





























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import FormField from '@/components/form/FormField.vue';
import { ValidationError } from 'class-validator';
import i18next from 'i18next';

@Component({
  components: { FormField },
})
export default class UploadField extends Vue {
  @Prop(String)
  public identifier!: string;

  @Prop(String)
  public placeholder!: string;

  @Prop({ type: Boolean, default: true })
  public labelIsPath!: boolean;

  @Prop(String)
  public label!: string;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Boolean)
  public isMandatory!: boolean;

  @Prop(Array)
  public options!: Array<{ value: string | number; label: string | number }>;

  @Prop(Object)
  public validationError!: ValidationError | null;

  @Prop(String)
  public value!: string | null;

  public filename: string = '';

  public get translatedPlaceholder(): string {
    if (!this.placeholder) {
      return '';
    }
    return this.translate(this.placeholder);
  }

  @Emit()
  public infoClick(): void {}

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }

  public onChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.filename = target.files[0].name;

      if (!this.allowedTypes().includes(target.files[0].type)) {
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: i18next.t('upload.wrongFormat.title'),
            message: i18next.t('upload.wrongFormat.body'),
          },
        });
        this.$emit('input', undefined);
        return;
      }

      const fileReader = new FileReader();
      fileReader.readAsDataURL(target.files[0]);
      fileReader.onload = () => {
        this.$emit('input', fileReader.result);
        target.type = 'text';
        target.type = 'file';
      };
    }
  }

  get allowedTypesAsString() {
    return this.allowedTypes().join(',');
  }

  private allowedTypes(): string[] {
    return ['application/pdf', 'image/png', 'image/jpeg'];
  }
}
